export const state = () => ({
  appBar: true
})

export const mutations = {
  setAppBarVisible(state, isVisible) {
    state.appBar = isVisible
  }
}

export const actions = {
  hideAppBar({ commit }) {
    commit('setAppBarVisible', false)
  },

  showAppBar({ commit }) {
    commit('setAppBarVisible', true)
  }
}

export const getters = {
  isAppBarVisible: (state) => state.appBar
}
